<template>
    <div class='top-nav'>
        <a href="#">{{ $t('components.TopNav.1') }}</a>
        <a class='no-mobile' href="#">{{ $t('components.TopNav.2') }}</a>
        <a class='no-mobile' href="#">{{ $t('components.TopNav.3') }}</a>
    </div>
</template>

<script>
</script>

<style lang="scss" scoped>
@import "@/scss_variables/variables";
    .top-nav {
        a {
            color: $font-semidark;
        }
        a:first-child {
            color: $font-dark;
            font-size: 1.2rem;
        }
        a:hover {
            color: $font-dark;
        }
    }
</style>